export default __webpack_public_path__ + "76681d39d5a7714201f7f1ab31eb6c50.png";